module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}\r\n.holder1{\r\n    margin-top: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/allot-notallot/allot-notallot.component.css
// module id = ./src/app/applicant/allot-notallot/allot-notallot.component.css
// module chunks = main